import React from 'react';
import { Link } from 'react-router';
import parser from 'Utils/bbcode/BBCodeParser';
import decode from 'Utils/entities';
import Quote from 'Components/posts/QuoteComponent';
import TweetComponent from 'Components/posts/tweetComponent';
import LiveStream from 'Components/posts/livestreamComponent';
import SvgIcon from 'Components/svg/SvgIcon';

function convertCodeBlock(codeBlockObject, props) {
	let style = {};
	let {open: {tag, attributes}, content, close} = codeBlockObject;

	switch (tag) {
		case 'quote':
			let username = '', id = 0;

			if( typeof attributes === 'string' ) {
				[ username, id ] = attributes.indexOf( ';' ) < 0 ? [ attributes, 0 ] : attributes.split( ';' );
			}
			if( content ) {
				return (
					<Quote key={ 'quote_' + key_counter }
						postId={ parseInt( id ) }
						userName={ username }
						posts={ props.posts || {} }
						users={ props.users || {} }>
						{ recurseConvert( content, props ) }
					</Quote>
				);
			} else {
				return `[${tag}${attributes || ''}]`;
			}

		case 'list':
			let newList = [], open = false, lineNo = 0;
			// we can have single tags [*] for <li> elements
			// we need to group lines in same li element
			content.forEach( c => {
				if( c.close === null && c.open.tag === '*' ) {
					lineNo++;
					c.close = { tag: 'li' };
					c.open.tag = 'li';
					c.content = [];
					open = true;
					newList[ lineNo ] = c;

				} else if( open ) {
					newList[ lineNo ].content.push( c );
				}
			});

			let newContent = newList.length ? newList : content,
				lines = newContent.map(
					c => {
						switch( typeof c ) {
							case 'string':
								return c.split( '\n' ).filter( t => t !== '' );

							default:
								key_counter++;
								return convertCodeBlock( c, props );
						}
					}
			).filter(l => l.length !== undefined ? l.length > 0 : true);

			if( attributes === "1" ) {
				return (
					<ol key={ key_counter }>
						{ lines.length  && lines[ 0 ].length ? lines[ 0 ] : lines }
					</ol>
				);

			} else {
				return (
					<ul key={ key_counter }>
						{ lines.length  && lines[ 0 ].length ? lines[ 0 ] : lines }
					</ul>
				);
			}

		case 'email':
			return <a key={ key_counter } href={ `mailto:${ attributes || content }` } data-rel="external">{ recurseConvert(content, props) }</a>;

		case 'code':
		case 'html':
		case 'php':
			return <pre key={ key_counter }>{ recurseConvert(content, props) }</pre>;

		case 'justify':
		case 'center':
		case 'right':
		case 'left':
			return <p key={ key_counter } className={ `text-align-${tag}` }>
				{ recurseConvert(content, props) }
			</p>;

		case 'size':
			style = {
				fontSize: (attributes < 8) ? 8 : ( attributes > 32 ? 32 : attributes ) + 'px'
			};
			return <span key={ key_counter } style={ style } >{ recurseConvert(content, props) }</span>;

		case 'font':
			return <span key={ key_counter } >{ recurseConvert(content, props) }</span>;

		case 'indent':
			return <span key={ key_counter } className="text-indented">{ recurseConvert(content, props) }</span>;

		case 'url':
			if( attributes ) { // if the url is a video embed it
				let is_video = is_embed_video( attributes );
				if( is_video ) {
					// Adapt the block to videos tags
					codeBlockObject.open.attributes = ( typeof content !== 'string' && typeof content[ 0 ] === 'string' ) ? content[ 0 ] : content;
					codeBlockObject.content = attributes;
				} else {
					is_video = is_embed_video( content[ 0 ] );
					if( is_video ) {
						codeBlockObject.open.attributes = is_video;
						codeBlockObject.content = ( typeof content !== 'string' && typeof content[ 0 ] === 'string' ) ? content[ 0 ] : content;
					}
				}

				if( is_video ) {
					codeBlockObject.open.tag = is_video;
					return <div key={ `video_${ key_counter }` }><em key={ `videotitle_${ key_counter }` } className="videoembed_title">{ codeBlockObject.open.attributes }</em>
						{ convertCodeBlock(codeBlockObject, props) }
					</div>;
				} else {
					let href = ( typeof attributes === 'string' ? attributes : content[ 0 ] ).replace( /(^&quot;)|(&quot;$)/ig, '');
					return <a key={ key_counter } href={ href } target="_blank">
						{ recurseConvert( content, props ) }
					</a>;
				}
			} else {
				return embed_video( content );
			}

		case 'ame':
			if( typeof attributes === 'string' && attributes.match(/youtu(?:be\.com|\.be)/i) ) {
				let title = ( typeof content !== 'string' && typeof content[0] === 'string' ) ? content[0] : content;
				return <div><em className="videoembed_title">{ title }</em>
					{ embed_video( attributes ) }
					</div>;
			}

			if( typeof content !== 'string' && typeof content[0] === 'string' && content[0].match(/youtu(?:be\.com|\.be)/i) ) {
				return embed_video( content[0] );
			}

			if( attributes && attributes.length > 0 && content ) {
				return <a href={ attributes } target="_blank" key={ key_counter }>
					{ recurseConvert( content, props ) }
				</a>;
			}
			return embed_video( content );

		case 'video':
			let video_data = attributes,
				is_video = is_embed_video( attributes );

			if( !is_video ) {
				is_video = is_embed_video( content );
				video_data = content;
			}
			return embed_video( video_data, is_video );

		case 'youtube':
		case 'youtubehd':
		case 'youtube_browser':
			if( content.indexOf(':') < 0 ) {
				content = 'https://www.youtube.com/watch?v=' + content;
			}
			return embed_video( content, 'youtube' );

		case 'dm': // dailymotion
		case 'metacafe': // metacafe
		case 'vimeo': // vimeo
		case 'soundcloud': // SoundCloud
			return embed_video( content, tag );

		case 'tweet': // twitter
			let tweetid = content[0];

			if( content[0].indexOf( '://' ) >= 0 ) {
				let newtweetid = /\d+$/.exec( tweetid );
				tweetid = newtweetid[0];
			}
			let tweetElementsId = `tweet_${ tweetid }_${ (new Date()).getTime() }${parseInt( Math.random() * 1000 )}`;

			return <TweetComponent key={ key_counter } tweetid={ tweetid } tweetElementsId={ tweetElementsId } />;

		case 'thread':
		case 'post': // internal links
			let type = tag === 'post' ? `0?postid=` : '',
				itemId = attributes.length ? attributes : content[0] ;
			return <Link key={ key_counter } to={ `/topics/${ type }${ itemId }` } className="link">{ content }<SvgIcon size="16px" icon="link" /></Link>;

		case 'gs': // Google Spreadsheet
			return <a key={ key_counter } href={ `https://spreadsheets.google.com/pub?key=${ content }&hl=en&single=true&gid=0&output=html` } target="_blank">Open this Spreadsheet.</a>;

		case 'gd': // Google Document
			return <a key={ key_counter } href={ `https://docs.google.com/document/pub?id=${ content }` } target="_blank">Open this Google Document.</a>;

		case 'gp': // Google Presentation
			return <a key={ key_counter } href={ `https://docs.google.com/present/view?id=${ content }` } target="_blank">Open this Presentation.</a>;

		case 'iurl':
			return <span key={ key_counter } className="inline_image">
				<a key={ 'a_' + key_counter } href={ attributes } target="_blank">
					{ recurseConvert(content, props) }
				</a>
			</span>;

		case 'color':
			style = { color: attributes };
			return <span key={ key_counter } style={ style }>{ recurseConvert(content, props) }</span>;

		case 'img':
			return <img key={ key_counter } src={ content[0] } />;
		case 'imgnoism': // no ISM nor netseer
			return <img key={ key_counter } src={ content[0] } className="no-ad" />;
		case 'noviglink': // No Viglink content
			return <div key={ key_counter } className="p nolinks">{ recurseConvert(content, props) }</div>;
		case 'nointellitxt': // No Vibrant
			return <span key={ key_counter } id="nointelliTXT">{ recurseConvert(content, props) }</span>;

		case 'info':
			return <span key={ key_counter } className="info"><SvgIcon size="20px" icon="info" />{ recurseConvert(content, props) }</span>;
		case 'warn':
			return <span key={ key_counter } className="warning"><SvgIcon size="20px" icon="warning" />{ recurseConvert(content, props) }</span>;

		case 'highlight':
			return <span key={ key_counter } className="highlight">{ recurseConvert(content, props) }</span>;

		case 'mention':
			// Link to user profile - will show the @user
			return <em key={ key_counter }>
						@<Link key={ `link_${ key_counter }` } to={ `/userprofile/${ content }` } className="link">{ content }</Link>
					</em>;

		case 'scroll':
			return <marquee key={ key_counter }>{ recurseConvert(content, props) }</marquee>;
		case 'i':
		case 'em':
			return <em key={ key_counter }>{ recurseConvert(content, props) }</em>;
		case 'b':
			return <strong key={ key_counter }>{ recurseConvert(content, props) }</strong>;
		case 's':
			return <del key={ key_counter }>{ recurseConvert(content, props) }</del>;
		case 'sub':
			return <sub key={ key_counter }>{ recurseConvert(content, props) }</sub>;
		case 'u':
			return <span key={ key_counter } style={ { textDecoration: 'underline' } }>{ recurseConvert(content, props) }</span>;
		case 'sup':
			return <sup key={ key_counter }>{ recurseConvert(content, props) }</sup>;

		case 'ol':
			return <ol key={ key_counter }>{ recurseConvert( cleanExtraCR(content), props) }</ol>;
		case 'ul':
			return <ul key={ key_counter }>{ recurseConvert( cleanExtraCR(content), props) }</ul>;
		case 'li':
			return <li key={ key_counter }>{ recurseConvert(content, props) }</li>;

		case 'table':
			return <table key={ key_counter }>
				{ recurseConvert(content, props) }
			</table>;
		case 'tr':
			return <tr key={ key_counter }>
				{ recurseConvert(content, props) }
			</tr>;
		case 'th':
			return <th key={ key_counter }>
				{ recurseConvert(content, props) }
			</th>;
		case 'td':
			return <td key={ key_counter }>
				{ recurseConvert(content, props) }
			</td>;

		case 'livestream':
			if( content && content.length > 0 ) {
				return <LiveStream content={ content[0] } key={ key_counter } />;
			}
			return null;

		case 'spoiler':
			return <div className="spoilerAlert">
						<p>Spoiler Alert <em onClick={ (e) => showSpoiler(e) }>Show</em></p>
						<div className="spoiler-message hidden">{ recurseConvert(content, props) }</div>
					</div>;

		default:
			if( close ) {
				return <span key={ key_counter } >
					{ `[${tag}${attributes || ''}]` }
					<span key={ key_counter } >{ recurseConvert(content, props) }</span>
					{ `[${close.tag}]` }
				</span>;
			} else {
				return <span key={ key_counter } >{ `[${tag}${attributes || ''}]` }</span>;
			}
	}
}

let key_counter = 0,
	allowHTML = false;

function recurseConvert(parseArray, props) {
	let sub_key_counter = 0;
	return parseArray.map(e => {
		key_counter++;
		if( typeof e === 'string' ) {
			if( e ) {
				sub_key_counter++;
				// We dangerously set innerhtml here because vbulletin pre-sanitizes the content
				return e !== "\n" ? <span key={ key_counter + '_' + sub_key_counter } dangerouslySetInnerHTML={ { __html: ( allowHTML ? decode( e ) : e ).replace( /\n/ig, '<br />') } }/> : null;
			}
			return false;
		} else {

			if( e.content || e.attributes ) { // convert if we have content or attributes
				return convertCodeBlock( e, props );

			} else if( e.open.tag ) { // malformed tags? let's leave them
				let _tag = '[' + e.open.tag + ']'; // recreate the tag
				return <span key={ key_counter } dangerouslySetInnerHTML={ { __html: _tag } }/>;
			}
		}
	});
}

// Cleans extra carriage returns between elements
function cleanExtraCR( content ) {
	let re = /^[\n|\r]+$/;
	return content ? content.filter( e => !( typeof e === 'string' && re.test( e ) ) ) : [];
}

// Checks for potential embed videos
function is_embed_video( content ) {
	let videoSites = [
		{ type: 'youtube', reg: 'youtu(?:be\.com|\.be)\/(?:watch\?v=)?([a-z0-9\-\_]+)' },
		{ type: 'soundcloud', reg: 'soundcloud.com\/player\/[?]url=.+' },
		{ type: 'vimeo', reg: 'player.vimeo.com\/video\/.+' },
		{ type: 'metacafe', reg: 'metacafe.com\/embed\/.+' },
		{ type: 'dm', reg: 'dailymotion.com\/embed\/video\/.+' } // dailymotion
	];

	if( typeof content === 'object' ) {
			content = content.length > 0 ? content[0] : '';
	}

	for( let i = 0; i < videoSites.length; i++ ) {
		let video = videoSites[i],
			re = new RegExp( video.reg, 'i' );
		if( re.test( content ) ) {
			return video.type;
		}
	}

	return false;
}

// video embeding or not
function embed_video( content, type = false ) {
	if( typeof content === 'object' ) {
		content = content.length > 0 ? content[0] : '';
	}

	switch( type ) {
		case 'dm': // dailymotion
			return <iframe key={ key_counter } className="videoembed" src={ `https://www.dailymotion.com/embed/video/${content}` } frameBorder="0" />;

		case 'metacafe': // metacafe
			return <iframe key={ key_counter } className="videoembed" src={ `https://www.metacafe.com/embed/${content}` } allowFullScreen frameBorder="0" />;

		case 'vimeo': // vimeo
			return <iframe key={ key_counter } className="videoembed" src={ `https://player.vimeo.com/video/${content}` } frameBorder="0" allowFullScreen />;

		case 'soundcloud': // SoundCloud
			return <iframe key={ key_counter } className="videoembed" scrolling="no" frameBorder="no" src={ `https://w.soundcloud.com/player/?url=${ encodeURIComponent( content ) }&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&visual=true`} />;

		case 'youtube':
		default:
			// is a youtube video?
			let _ym = content.match( /youtu(?:be\.com|\.be)\/(?:watch\?v=)?([a-z0-9\-\_]+)/i );
			if( _ym && _ym[ 1 ] ) {
				let _youtube = 'https://www.youtube.com/embed/' + _ym[ 1 ];
				return <iframe key={ key_counter } className="videoembed" src={ _youtube } frameBorder="0" allowFullScreen />;

			} else {
				return <a key={ key_counter } href={ content } target="_blank">{ content }</a>;
			}
	}
}

function showSpoiler( e ) {
	e.stopPropagation();

	e.target.classList.add( 'hidden' );
	e.target.parentNode.nextSibling.classList.remove( 'hidden' );
	return true;
}

export default function( rawBody, props, html = false ) {
	let { status, value, expected, index } = parser.parse( rawBody );
	key_counter = 0;
	allowHTML = html;

	if( status ) {
		return recurseConvert( value, props );
	} else {
		key_counter++;
		topifyConsole.error( "Failed to parse, expected:", expected, " at index", index );
		topifyConsole.log( rawBody.slice( index - 100, index + 200 ) );
		return <span key={ key_counter } dangerouslySetInnerHTML={ { __html: rawBody } }/>;
	}
}



// WEBPACK FOOTER //
// ./src/utils/bbcode/RawToReact.js